import { render, staticRenderFns } from "./ExcHeaderLabelCreator.vue?vue&type=template&id=656d139e&scoped=true&"
import script from "./ExcHeaderLabelCreator.vue?vue&type=script&lang=js&"
export * from "./ExcHeaderLabelCreator.vue?vue&type=script&lang=js&"
import style0 from "./ExcHeaderLabelCreator.vue?vue&type=style&index=0&id=656d139e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656d139e",
  null
  
)

export default component.exports